import { useState, useEffect } from 'react'
import { KEY_CODE_MAP } from 'Defaults'

const useListKeyboardInteraction = (
  {
    parentClassName,
    enableKeyboardInteraction,
    childClassName,
    onFocusOut,
    onSelect = () => {},
    updateOpenState,
    isDropdownOpen = false,
  },
) => {
  const [activeIndex, updateActiveIndex] = useState(-1)
  useEffect(() => {
    if(!enableKeyboardInteraction) updateActiveIndex(-1)
    const eventHandler = (e) => {
      if(!enableKeyboardInteraction) return null
      let newIndex = activeIndex
      const childNodeList = document.querySelectorAll(childClassName) || []
      switch(e.keyCode) {
        case KEY_CODE_MAP.ENTER:
          onSelect(activeIndex)
          break
        case KEY_CODE_MAP.ARROW_UP:
          if(activeIndex > 0) {
            newIndex = activeIndex - 1
          } else if(activeIndex < 1) {
            newIndex = childNodeList.length - 1
          }
          break
        case KEY_CODE_MAP.ARROW_DOWN:
          if(activeIndex < childNodeList.length - 1) {
            newIndex = activeIndex + 1
          } else if(activeIndex === childNodeList.length - 1) {
            newIndex = 0
          }
          // focus on native select open on arrow down
          if(!isDropdownOpen && updateOpenState) {
            updateOpenState(true)
          }
          break
        case KEY_CODE_MAP.HOME:
          newIndex = 0
          break
        case KEY_CODE_MAP.END:
          newIndex = childNodeList.length - 1
          break
        case KEY_CODE_MAP.TAB:
          if(updateOpenState) {
            updateOpenState(false)
            onFocusOut()
          }
          break
        case KEY_CODE_MAP.ESC:
          if(onFocusOut) onFocusOut()
      }
      const currentElem = childNodeList[newIndex]
      if(activeIndex !== newIndex && newIndex > -1) {
        updateActiveIndex(newIndex)

        if(currentElem) {
          currentElem.setAttribute('aria-selected', true)
          currentElem.focus()
        }
      } else if(currentElem && childNodeList) {
        currentElem.setAttribute('aria-selected', false)
      }
      // call focus out on tab on last item
      if(e.keyCode === KEY_CODE_MAP.TAB && newIndex === childNodeList.length - 1 && onFocusOut) {
        onFocusOut()
      }
    }

    document.addEventListener('keydown', eventHandler)
    return () => document.removeEventListener('keydown', eventHandler)
  }, [enableKeyboardInteraction, activeIndex])

  // focus on parent select
  useEffect(() => {
    if(enableKeyboardInteraction && parentClassName) {
      const parentElem = document.querySelector(parentClassName)
      if(parentElem && activeIndex === -1) {
        parentElem.focus()
      }
    }
  }, [enableKeyboardInteraction, activeIndex])
  return {
    activeIndex,
    updateActiveIndex,
  }
}

export default useListKeyboardInteraction
